<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1 class="text-h4 mb-4">Configuration IA</h1>
        <p class="text-subtitle-1 text-grey mb-6">
          Configurez les modèles de langage et les services d'intelligence artificielle
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Paramètres IA</v-card-title>
          <v-card-text>
            <p>Configuration des services d'IA à implémenter.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
// Placeholder for LLM settings
</script>
